module.exports = __webpack_public_path__ + "img/defaultPicture1.695a1c54.png";